var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-form-item",
    { attrs: { label: _vm.$t("settingOrderMoney.amountType"), prop: "type" } },
    [
      _c("BjSelectLov", {
        attrs: {
          "option-list": _vm.ORDER_MONEY_TYPE_LIST,
          loading: _vm.loading,
        },
        model: {
          value: _vm.id,
          callback: function ($$v) {
            _vm.id = $$v
          },
          expression: "id",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }